import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import { videoPopup } from '../../../../../../../../../../../actions/popupActions';
import { isUpgradeToBusinessShownAndActivated as setIsUpgradeToBusinessShownAndActivated } from '../../../../../../../../../../../actions/contactActions';
import Icon from '../../../../../../../../../../components/icon';
import Button from '../../../../../../../../../../components/button';
import {API_ROOT} from '../../../../../../../../../../utils';
import {postEngagement} from '../../../../../../../../../../../actions/engagementActions';
import './index.css';

function UpgradeToBusiness () {

    const [video, setVideo] = useState({
		id: 'Dr1wBIrhLzo',
		preview: API_ROOT + '/img/7-reasons-to-upgrade-en.jpg'
	});

    const { t } = useTranslation();
    const language = useSelector(state => state.languageReducer.language);
	const isUpgradeToBusinessShownAndActivated = useSelector(state => state.contactReducer.isUpgradeToBusinessShownAndActivated);

	const dispatch = useDispatch();

    const handlePlay = () => {
	    dispatch(postEngagement(58, new Intl.DateTimeFormat('fr-FR', {
		    day: '2-digit',
		    month: '2-digit',
		    year: '2-digit',
		    hour: '2-digit',
		    minute: '2-digit',
		    second: '2-digit',
	    }).format()));

	    dispatch(videoPopup(video.id));
	};

	useEffect(() => {
		switch (language) {
			case 'fr' :
				setVideo({
					id: '7yg9nr41gTw',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-fr.jpg'
				});
				break;
			case 'es' :
				setVideo({
					id: 'iGwo6QCf6bc',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-es.jpg'
				});
				break;
			default :
				setVideo({
					id: 'Dr1wBIrhLzo',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-en.jpg'
				});
				break;
		}
	}, [language]);

	const close = () => {
		dispatch(setIsUpgradeToBusinessShownAndActivated(false));
	};

	const handleClick = () => {
		if(!isUpgradeToBusinessShownAndActivated){
			dispatch(setIsUpgradeToBusinessShownAndActivated(true));
		}
	};

    return (
        <div onClick={ handleClick } className={`upgrade-to-business${!isUpgradeToBusinessShownAndActivated ? ' is-hidden' : ''}`}>
            <div className="upgrade-to-business__content">
				<button className="close" onClick={close}>
					<svg width="34" height="34" viewBox="0 0 34 34" fill="none"
							xmlns="http://www.w3.org/2000/svg">
						<path fillRule="evenodd" clipRule="evenodd"
								d="M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17ZM8.38383 25.6162C7.79804 25.0304 7.79804 24.0807 8.38383 23.4949L14.8787 17L8.38374 10.5051C7.79795 9.91932 7.79795 8.96957 8.38374 8.38378C8.96952 7.798 9.91927 7.798 10.5051 8.38378L17 14.8787L23.4949 8.38378C24.0807 7.798 25.0305 7.798 25.6163 8.38378C26.202 8.96957 26.202 9.91932 25.6163 10.5051L19.1213 17L25.6162 23.4949C26.202 24.0807 26.202 25.0304 25.6162 25.6162C25.0304 26.202 24.0806 26.202 23.4949 25.6162L17 19.1214L10.5052 25.6162C9.91936 26.202 8.96962 26.202 8.38383 25.6162Z"
								fill="#FF1938"/>
					</svg>
				</button>
                <h2>{t('upgradeToBusinessTitle')}</h2>
                <p>{t('upgradeToBusinessContent')}</p>
                <div>
                    <button className="video-button" onClick={handlePlay}>
                        <Icon name="play-circle" />
                        <img data-video={video.id} className="d-block" src={video.preview} width="300" alt=""/>
                    </button>
                </div>
                <div>
					<a href={`/api/payment/upgrade`} target="_blank" rel="noreferrer" className="btn btn-primary">{t('upgradeToBusinessBtn')}</a>
                </div>
	            <div>
		            <Button className="mt-3 btn-link" onClick={close}>{t('upgradeToBusinessSkip')}</Button>
	            </div>
            </div>
        </div>
    )
}

export default UpgradeToBusiness;
